import { create } from 'zustand'
// Only transient presentation state. Authentication and persistent data live elsewhere.
export const useUIStore = create<{
  drawerOpen: boolean
  setDrawerOpen: (open: boolean) => void
  sidebarCollapsed: boolean
  posSidebarCollapsed: boolean
  toggleSidebar: (pos?: boolean) => void
}>((set) => ({
  drawerOpen: false,
  setDrawerOpen: (drawerOpen) => set({ drawerOpen }),
  sidebarCollapsed: false,
  posSidebarCollapsed: true,
  toggleSidebar: (pos = false) =>
    set((state) =>
      pos
        ? { posSidebarCollapsed: !state.posSidebarCollapsed }
        : { sidebarCollapsed: !state.sidebarCollapsed },
    ),
}))
